module.exports = __webpack_public_path__ + "static/flags/LR-bec3ab7e628cf3c3dc3d2bbe3c50925d.gif";